<template>
    <div
        :class="{
            'sm:border-t sm:border-gray-200 sm:py-5' : withBorder,
            'space-y-1 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4': isInline
        }"
    >
        <label v-if="label" :for="id"
               :class="{
                   'block text-sm font-bold text-gray-900': true,
                   'mb-2': !isInline,
                   'sm:mt-px sm:pt-2': isInline
                }"
        >
            {{ label }} {{ required ? '*' : '' }}
        </label>

        <div :class="isInline ? 'sm:col-span-2' : 'w-full'">
            <Multiselect
                v-model="mutableValue"
                :options="options"
                :placeholder="placeholder"
                :searchable="searchable"
                :mode="mode"
                :name="name"
                :loading="isPending"
                :create-option="createOption"
                @change="handleChange"
                @select="handleSelect"
                @clear="handleClear"
                @deselect="handleSelect"
            />

            <div v-if="tooltip || errors && errors.length > 0" class="flex flex-row justify-between mt-2">
                <p v-if="errors && errors.length > 0" v-for="error in errors" class="text-red-500 text-xs italic mb-0 mt-1">{{ error }}</p>
                <p v-if="tooltip" class="mt-2 text-sm text-gray-500">{{ tooltip }}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from '@vueform/multiselect'
    import '@vueform/multiselect/themes/default.css'

    export default {
        props: {
            modelValue: [String, Array, Number],
            placeholder: String,
            name: String,
            label: String,
            options: Array,
            mode: {
                type: String,
                default: 'single'
            },
            id: String,
            searchable: Boolean,
            taggable: Boolean,
            errors: Array,
            touched: Boolean,
            tooltip: String,
            withBorder: Boolean,
            createOption: Boolean,
            required: Boolean,
            isInline: Boolean,
            isPending: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                mutableValue: this.modelValue
            }
        },
        components: {
            Multiselect,
        },
        methods: {
            handleChange(value) {
                this.$emit('change', value);
            },
            handleSelect() {
                this.$emit('update:modelValue', this.mutableValue);
            },
            handleClear() {
                this.$emit('update:modelValue', null)
            }
        },
    }
</script>
